import React from "react";
import Button from "@dtci/spellbook/Button";
import Icon from "@dtci/spellbook/Icon";
import { StageId } from "ppt/constants";
import styles from "./pptStatusLifecycle.module.scss";

/**
 * Primary action for the current stage. Renders as a plain button (parent
 * positions it). Three states reflect the gate evaluation:
 *   - clean    → enabled, single click advances
 *   - warnings → enabled, click opens acknowledgment modal
 *   - blocked  → disabled
 *
 * Special case: DATA_SYNC stage shows a waiting message instead of a button,
 * as the transition happens automatically when enrichment data is ready.
 */
export const ActionBar = ({
  gateEvaluation,
  onComplete,
  isLoading,
  currentStageId,
}) => {
  // DATA_SYNC stage has no manual complete action - show warning-styled waiting message instead
  if (currentStageId === StageId.DATA_SYNC) {
    return (
      <span className={styles.waitingMessage}>
        <Icon
          iconType="fa"
          faPackage="fal"
          iconName="fa-clock"
        />
        Waiting for enrichment data
      </span>
    );
  }

  const getButtonLabel = () => {
    switch (currentStageId) {
      case StageId.PORTAL_UPLOAD:
        return "Download Complete";
      default:
        return "Complete Stage";
    }
  };

  const buttonLabel = getButtonLabel();
  const allowed = gateEvaluation.allowed;
  return (
    <Button
      styleType="standard"
      iconPlacement="before"
      iconType="fa-check"
      isFetching={isLoading}
      disabled={!allowed && gateEvaluation.mode === "blocked"}
      onClick={onComplete}
    >
      {buttonLabel}
    </Button>
  );
};
